// @flow

import * as React from 'react';

import s from './PickListItem.scss';

type Props = {
  name: string|number,
  selected: boolean,
  disabled: boolean,
  onItemClick: () => void,
}

export const PickListItem = (props: Props) => {
  const { name, selected, disabled, onItemClick } = props;
  let style = [s.list_item];
  if (selected) {
    style.push(`${s.list_selected}`);
  }
  return (
    <li
      className={style.join(' ')}
      onClick={ ()=> {onItemClick()} }
    >
      <button
        className={s.item_button}
        disabled={disabled}
        style={disabled ? {color: 'lightgrey'} : null}
      >
        {name}
      </button>
    </li>
  )
}



export default PickListItem;